"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggles = void 0;
var Toggles;
(function (Toggles) {
    class Handler {
        static toggleAvailable(toggleName) {
            const bodyElem = document.querySelector('body');
            if (!bodyElem) {
                return false;
            }
            const togglesJson = bodyElem.dataset.toggles;
            if (!togglesJson || togglesJson.length === 0) {
                return false;
            }
            const togglesArray = JSON.parse(togglesJson);
            return togglesArray.includes(toggleName);
        }
    }
    Toggles.Handler = Handler;
})(Toggles || (exports.Toggles = Toggles = {}));
